export const API_ADRESSE_GOUV_URL =
  process.env.REACT_APP_API_ADRESSE_GOUV_URL || '';
